import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import BackgroundElements from './background-elements/BackgroundElements';

const HomeScreen = ({ setScreenNumber }) => {
  return (
    <div className={styles.container}>
      <div
        className={styles.content}
        style={{
          backgroundImage: `url(${getImageFromS3('images/25-sms-lm-ssl/bg.png')})`
        }}
      >
        <BackgroundElements />
        <img
          className={styles.staticFlower}
          src={getImageFromS3('images/25-sms-lm-ssl/static-flower.png')}
          alt="staticFlower"
        />
        <img
          className={styles.logo}
          src={getImageFromS3('images/25-sms-lm-ssl/logo.png')}
          alt="logo"
        />
        <p className={styles.title}>
          Тепер
          <br />і у супертонкому форматі
        </p>
        <img
          className={styles.packs}
          src={getImageFromS3('images/25-sms-lm-ssl/packs.png')}
          alt="packs"
        />
        <div className={styles.filterContainer}>
          <p>
            Класичний
            <br /> ацетатний фільтр
          </p>
          <img
            src={getImageFromS3('images/25-sms-lm-ssl/filter.png')}
            alt="filter"
          />
        </div>
        <div className={styles.tobaccoContainer}>
          <img
            src={getImageFromS3('images/25-sms-lm-ssl/tobacco.png')}
            alt="tobacco"
          />
          <p>
            Тютюнова
            <br /> суміш від L&M
          </p>
        </div>
        <div className={styles.qrContainer}>
          <div className={styles.textContainer}>
            <p className={styles.title}>QR-код всередині пачки</p>
            <p className={styles.description}>За ним можна:</p>
            <ul>
              <li>Залишити відгук</li>
              <li>Знайти додаткову інформацію про продукт</li>
            </ul>
          </div>
          <img src={getImageFromS3('images/25-sms-lm-ssl/qr.png')} alt="qr" />
        </div>
        <div className={styles.formatContainer}>
          <p className={styles.title}>Формат</p>
          <p className={styles.description}>
            "100" Super Slims (довгі супертонкі)
          </p>
          <img
            src={getImageFromS3('images/25-sms-lm-ssl/format.png')}
            alt="format"
          />
        </div>
        <div className={styles.quizContainer}>
          <div className={styles.quizContent}>
            <h2>Актуальний асортимент</h2>
            <h3>
              можна знайти у роздрібних точках продажу в твоєму місті або на
              офіційних онлайн сервісах, зокрема:
            </h3>
            <div className={styles.quizButtonContainer}>
              <button
                className={styles.quizButton}
                onClick={() =>
                  window.open(
                    'https://rozetka.com.ua/ua/sigareti/c4638591/producer=b84d5fce;tolshchina139079=tonkie/?utm_source=PMU_sms_LM-ssl',
                    '_blank'
                  )
                }
              >
                <p>Rozetka</p>
                <img
                  src={getImageFromS3('images/25-sms-lm-ssl/button-glass.png')}
                  alt="quiz-glass"
                />
              </button>
              <button
                className={styles.quizButton}
                onClick={() =>
                  window.open(
                    'https://cig-poshta.in.ua/product-tag/lm-superslims-fc/?utm_source=cda_LM-ssl',
                    '_blank'
                  )
                }
              >
                <p>Cig-Poshta</p>
                <img
                  src={getImageFromS3('images/25-sms-lm-ssl/button-glass.png')}
                  alt="quiz-glass"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає
        <br />
        серйозні
        <br />
        захворювання та
        <br />
        залежність
        <br />
        Дана інформація про
        <br />
        продукт надається
        <br />
        відповідно
        <br />
        до статті 15 Закону
        <br />
        України «Про захист
        <br />
        прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) лист, оскільки
        <br />
        залишав(-ла) запит на отримання
        <br />
        інформації про продукцію компаній Philip
        <br /> Morris в Україні.
        <br />
        <a href="/unsubscribe?returnLink=25-sms-lm-ssl">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
